import type { LinkMap } from "@saflib/links";

const subdomain = "app";

export const appLinks: LinkMap = {
  // BEGIN WORKFLOW AREA page-links FOR vue/add-view

  home: {
    subdomain,
    path: "/",
  } as const,
  onboarding: {
    subdomain,
    path: "/onboarding",
  },
  sellPart: {
    subdomain,
    path: "/sell-part",
  },
  myListingsDetail: {
    subdomain,
    path: "/my-portal/:id",
  },
  myListingsEdit: {
    subdomain,
    path: "/my-portal/:id/edit",
  },
  partsPageDetail: {
    subdomain,
    path: "/market/:id",
  },
  credit: {
    subdomain,
    path: "/credit",
  },
  creditStatement: {
    subdomain,
    path: "/credit/statement",
  },
  repair: {
    subdomain,
    path: "/repair",
  },
  myPortal: {
    subdomain,
    path: "/my-portal",
  },
  repairDetail: {
    subdomain,
    path: "/repair/:id",
  },
  // END WORKFLOW AREA
} as const;
